




"use strict";

export default class PageBackButton {

    constructor (button) {
        if ( button ) {
            if ( window.history.length > 1 ) {
                button.style.display = 'inline-block';
            }

            button.addEventListener('click', () => window.history.back());
        }
    }

}
